export const HOME_ROUTE = "/";
export const ABOUT_ROUTE = "/about-us";
export const SERVICE_ROUTE = "/service";
export const WORK_ROUTE = "/our-work";
export const PROFILE_ROUTE = "/";
export const CONTACT_ROUTE  = "/contact";
export const VEDIKSHA_ROUTE  = "/vedikshha";
export const GALLARY_ROUTE  = "/gallary";
